export default "__VITE_ASSET__863fe68d__"